import { render, staticRenderFns } from "./ProjectFeedsSampleFormGroup.vue?vue&type=template&id=56446e7f"
import script from "./ProjectFeedsSampleFormGroup.vue?vue&type=script&lang=js"
export * from "./ProjectFeedsSampleFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports